<template>
 <div class="ui vertical segment">
    <app-header v-if="showMenu" ></app-header>
    <div class="ui container">
    <div :class="[{'vuetable-wrapper ui basic segment': true}, loading]">
      <div id="demo" class="ui vertical stripe segment">
        <div id="content" class="ui basic segment">
          <h4 class="ui header">Integration Tracking</h4>
          
            <div class="ui grid">
              <div >
                <br />
                  <div class="ui left aligned nine wide column">
                     <div class="ui labeled icon input">
                      <div class="ui label">From Date  &nbsp;&nbsp;&nbsp; </div>
                      <Datepicker  ref="startDate"  :clearButton="true" :disabledDates="state.disabledDates" :highlighted="state.highlighted" v-model="fromDate"  
                      class="ui input" style="width:300px"></Datepicker>
                    </div>
                    <div class="ui labeled icon input">
                      <div class="ui label">To Date &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </div>
                      <Datepicker ref="endDate" :disabledDates="state.disabledDates" :highlighted="state.highlighted" v-model="endDate" :clearButton="true" id="endDate"  
                      class="ui input" style="width:300px" ></Datepicker>
                    </div>
                  </div>
                  <br /> 

                   <div class="ui left aligned nine wide column">
                   
                    <div class="ui labeled icon input">
                      <div class="ui label">Doc Type &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </div>
                     <select class="ui input" style="width:300px"  v-model="documentTypeSelected"  >
                      <option v-for="documenttype in documenttypes" v-bind:value="documenttype.doctype_id" v-bind:key="documenttype.doctype_id" >
                          {{ documenttype.description }}
                      </option>
                    </select>
                    </div>
                    
                    
                   
                  </div>
                  <br /> 
 
          
                <div class="ui left aligned nine wide column">
                    <div class="ui labeled icon input">
                      <div class="ui label">Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </div>
                      <input v-model="searchFor" class="ui input" @keyup.enter="setFilter" style="width:300px">
                      <i class="search icon"></i>
                    </div>
                    <button class="ui button primary" @click="setFilter">Search</button>
                    <button class="ui button" @click="resetFilter">Reset</button>
                   
                  </div>
                   <br /> 
              </div> 
                 
             
            
            

            </div>  
             <!--  detail-row-component="documenthistory-detail-row" -->
             <div class="ui grid">
               <downloadexcel
                      class = "btn"
                      :fetch   = "fetchExportTrackingData"
                      :fields = "excel_fields"
                      :before-generate = "startDownload"
                      :before-finish = "finishDownload"
                      type    = "csv">
                 <img   src="../../assets/download_excel.png" alt="Export to Excel" > 
                <!-- <img style="width:40px"  src="./sophistique_business_xls_256.png" alt="Export to Excel" > -->
                 </downloadexcel>
            </div>



            <vuetable ref="vuetable"
                api-url= "gettrackinglist/"
                :http-options="httpOptions"
                :http-fetch="fetchTrackingList"
                :fields="fields"
                :table-height="tableHeight"
                pagination-path="pagination"
                :sort-order="sortOrder"
                :multi-sort="multiSort"
                :per-page="perPage"
                :append-params="moreParams"
                :row-class="rowClassCB"
                :load-on-start="false"
                 detail-row-component="tracking-detail-row"
                detail-row-transition="expand"
                @vuetable:pagination-data="onPaginationData"
                @vuetable:load-success="onLoadSuccess"
                @vuetable:load-error="onLoadError"
                @vuetable:loading="showLoader"
                @vuetable:loaded="hideLoader"
                 @vuetable:cell-clicked="onCellClicked"
                @vuetable:initialized="onInitialized"
                @vuetable:data-reset="onDataReset"
                track-by="id"
              >
            </vuetable>
              <div class="vuetable-pagination ui bottom attached segment grid">
                <vuetable-pagination-info ref="paginationInfo"
                  :info-template="paginationInfoTemplate"
                ></vuetable-pagination-info>
                <component :is="paginationComponent" ref="pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></component>
              </div>

          
        </div><!-- content -->
      </div><!-- app -->
      </div><!-- vuetable-wrapper -->
    </div><!-- ui container -->
  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from '@/components/vuetable-2/Vuetable.vue'
import VuetablePagination from '@/components/vuetable-2/VuetablePagination.vue'
import VuetablePaginationDropdown from '@/components/vuetable-2/VuetablePaginationDropdown.vue'
import VuetablePaginationInfo from '@/components/vuetable-2/VuetablePaginationInfo.vue'
import Vue from 'vue'
import downloadexcel from "vue-json-excel";
import Header from '@/components/Header.vue';

import Datepicker from 'vuejs-datepicker';
import Sahred from '@/components/shared/shared.js'
import TrackingDetails from './TrackingDetails.vue'


let E_SERVER_ERROR = 'Error communicating with the server'

var nextDay = new Date();
nextDay.setDate(nextDay.getDate()+1);   

Vue.component('tracking-detail-row', TrackingDetails)


Vue.component('tracking-actions', {
  template: [
    '<div>',
      '<button id= "trackingEdit" class="ui blue button" @click="onTrackingClick(\'edit-tracking-item\', rowData)"><i class="edit icon"></i></button>',
    '</div>'
  ].join(''),
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
      onTrackingClick (action, data) {
      if(action == 'edit-tracking-item') {
        swal({
            title: "",
            text: "Redirecting to, Update Tracking details screen on new Tab!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Continue!",
            closeOnConfirm: true
        },() => {
            var  cryptobject ;
            var encrypted_docid;
            var encrypted_doctype;

            alert(data.document_id.toString());
             alert(data.doc_type_id.toString());


            cryptobject = CryptoJS.AES.encrypt(data.document_id.toString(), 'corcentric');
            this.encrypted_docid = {str: cryptobject }

            cryptobject = CryptoJS.AES.encrypt(data.doc_type_id.toString(), 'corcentric');
            this.encrypted_doctype = {str: cryptobject }
            
            let routeTrackingData = this.$router.resolve({name: 'TrackingUpdate',
            query: { docId : this.encrypted_docid.str,docType : this.encrypted_doctype.str }});
            window.open(routeTrackingData.href, '_blank');
             
        })
     }
  
    },
  }
})

let tableColumns = [
   {
    name: 'id',
    title: '<i class="unordered list icon"></i>',
    dataClass: 'left aligned',
    width: '25px',
    callback: 'showDetailRow'

  },
  {
    name: 'document_name',
    title: 'Document Name',
    dataClass: 'left aligned',
    sortField: 'document_name',
    width: '100px'
  },
  {
    name: 'po_number',
    dataClass: 'left aligned',
    title: 'PO Number',
    sortField: 'po_number',
    width: '100px',
 },
  
  {
    name: 'vendor_code',
    title: 'Vendor Code',
    titleClass: 'left aligned',
    sortField: 'vendor_code',
    dataClass: 'left aligned',
    width: '100px'
  },
  {
    name: 'buyer_code',
    title: 'Buyer Code',
    sortField: 'buyer_code',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    width: '100px'
  },
  {
    name: 'ship_code',
    title: 'Ship Code',
    sortField: 'ship_code',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
   
    width: '100px',
  },
  {
    name: 'doctype_description',
    title: 'Doc Type',
    sortField: 'doctype_description',
    dataClass: 'left aligned',
   
    width: '120px',
  },
  {
    name: 'status_description',
    title: 'Status',
    sortField: 'status_description',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    width: '120px',
  },
  
 {
    name: 'date_received',
    title: 'Date Received',
    sortField: 'date_received',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
   
    width: '120px',
  },
 
  /*
 {
    name: '__component:tracking-actions',
    title: 'Action',
    titleClass: 'left aligned',
    dataClass: 'left aligned',
    width: '30px'
  }
  
  */
]

let excelColumns = 
  {
      'Document ID' : 'document_id',
     'Guid' : 'guid',
    'Doc Name': 'document_name',
    'PO Number':'po_number',
    'Vendor Code': 'vendor_code',
    'Buyer Code': 'buyer_code',
    'Ship Code': 'ship_code',
    'Community ID':'community_id',
    'Buyer Name' : 'buyer_name',
    'Vendor Name': 'vendor_name',
   'Date Received':'date_received',
    'Document Type' : 'doctype_description',
    'Status' : 'status_description',
    'Error' : 'error',
    'Resolution' : 'resolution',
    'Notes' : 'notes'
  }


export default {
    components: {
    appHeader: Header,
    Vuetable,
    VuetablePagination,
    VuetablePaginationDropdown,
    VuetablePaginationInfo,
    Datepicker,
    downloadexcel
  },
  data () {
    return {
    isEmpty : false,
    isSelect : false,
    showMenu : true,
    tokenExpired : 0,
    communities : [],
    communitySelected : "",
    httpOptions: {
              headers: {
                  authorization: 'bearer ' + localStorage.getItem('id_token') 
              }
          },
    loading: '',
    BuyerCode : '',
    VendorCode : '',
    CorcentricCode : '',
    moreParams: { _page : '', _pPage : '', _sort : '' , _filter : '' },
    fields: tableColumns,
    excel_fields: excelColumns,
    tableHeight: '',
    vuetableFields: false,
    sortOrder: [{
        field: 'date_received',
        direction: 'asc',
    }],
    multiSort: true,
    paginationComponent: 'vuetable-pagination',
    perPage: 10,
    paginationInfoTemplate: 'Showing record: {from} to {to} from {total} item(s)',
    documentTypeSelected : '',
    documenttypes : [],
  
    searchFor: '',
    fromDate : '',
    endDate : '',
    state : {
      disabledDates: {
        from: nextDay // Disable all dates from tomorrw
      },
      highlighted: {
    dates: [ // Highlight today
      new Date()
    ]}
    },
   input: {
              trasactionids : []
            },
    
    refreshToken_Event_Fired : 0 ,
    diffMins : 0,
    errorStatusMassUpdateSelected:"",
    isEmpty : false,
    isSelect : false
   
 }
  },
  watch: {
    'perPage' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    'paginationComponent' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.pagination.setPaginationData(this.$refs.vuetable.tablePagination)
      })
    }
  },
  created(){
    if(!localStorage.getItem('id_token') ){
    this.$router.push({name: 'Login'});
    }else{   
    this.checkTokenExpired(); 
    this.checkuserAccess = Sahred.checkuserAccess ;
    this.checkuserAccess();
    this.bindDocumentType(); 
    this.setDates();
    
  }    
  },
  methods: {
    
  

    

    sessionExpired(errorStatus){
      if ((errorStatus === 403 || errorStatus === 401) && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!')
      }
    },
    transform (data) {
      let transformed = {}
      transformed.pagination = {
        total: data.total,
        per_page: data.per_page,
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        from: data.from,
        to: data.to
      }

      transformed.data = []
      ///this.selectedHistoryData = []
      //this.selectedHistoryData = data.data
      data = data.data

      for (let i = 0; i < data.length; i++) {
        transformed['data'].push({
          id: data[i].id,
          guid : data[i].guid,
          document_id : data[i].document_id,
          doc_type_id : data[i].doc_type_id,
          document_name: data[i].document_name,
          po_number: data[i].po_number,
          vendor_code: data[i].vendor_code,
          buyer_code : data[i].buyer_code,
          ship_code: data[i].ship_code,
          buyer_name: data[i].buyer_name,
          vendor_name: data[i].vendor_name,
          date_received:data[i].date_received,
          community_id : data[i].community_id,
          status_description : data[i].status_description,
          doctype_description : data[i].doctype_description,
          error : data[i].error,
          resolution : data[i].resolution,
          notes : data[i].notes
          })
      }
      return transformed
    },
      setFilter () {
          this.$refs.vuetable.selectedTo = [];
    this.moreParams['filter'] = this.searchFor;
    
    if(this.fromDate == null || this.fromDate == ""){
        this.moreParams['startdate'] = null;
      }else{
        this.moreParams['startdate'] = moment(this.fromDate).format('MM/DD/YYYY');
      }
      if(this.endDate == null || this.endDate == ""){
        this.moreParams['enddate'] = null;
      }else{
        this.moreParams['enddate'] = moment(this.endDate).format('MM/DD/YYYY');
      }

      this.$nextTick(function() {
      this.$refs.vuetable.refresh();
      })
      
    },
    fetchTrackingList:function(apiUrl, httpOptions) {
      this.checkTokenExpired();
      
      return axios.get
      (
        Vue.prototype.$hostname + apiUrl + this.documentTypeSelected + "/N/N"  , this.httpOptions
      ); 
    },
    bindDocumentType(){
        if(localStorage.getItem('id_token')){
         axios({ method: "GET", "url": Vue.prototype.$hostname + "lookup/documenttype", 
               "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.documenttypes = result.data;
                    this.documentTypeSelected  = "0";
                   }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
        } 
    },
    resetFilter () {
    
      this.searchFor = ''
      this.documentTypeSelected  = "0";
       this.$refs.vuetable.selectedTo = [];
      this.setDates()
      this.setFilter()
    },
      checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    setDates(){
      var startDate = new Date();
      startDate.setDate(startDate.getDate()-7);   
      this.fromDate = startDate;
      var today = new Date();
      today.setDate(today.getDate()); 
      this.endDate = today;
      
    },
    startDownload(){
      this.showLoader();
    },
    finishDownload(){
      this.hideLoader();
    },
  async fetchExportTrackingData(){
     
     let response
     this.checkTokenExpired();
     if(this.$refs.vuetable.countTableData > 0){
       this.httpOptions.headers['authorization'] = 'bearer ' +  localStorage.getItem('id_token')
        response = await axios.get(Vue.prototype.$hostname + 'gettrackinglist/' +  this.documentTypeSelected + "/N/Y" , this.httpOptions); 
        if(response.data.length == 0){
        sweetAlert('No data to Export!', '', 'error');
        this.hideLoader();
        }
     }else{
      sweetAlert('No data to Export!', '', 'error');
      this.hideLoader();
      return ;
     }
     return response.data;
    },

  
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
          this.refreshToken_Event_Fired = 0;
          console.error(error);
      });

    },
     showSettingsModal () {
      let self = this
      $('#settingsModal').modal({
        detachable: true,
        onVisible () {
          $('.ui.checkbox').checkbox()
        }
      }).modal('show')
    },
    showLoader () {
      this.loading = 'loading'
    },
    hideLoader () {
      this.loading = ''
    },
    showDetailRow (value) {
    let icon = this.$refs.vuetable.isVisibleDetailRow(value) ? 'down' : 'right'
    return [
        '<a class="show-detail-row">',
            '<i class="chevron circle ' + icon + ' icon"></i>',
        '</a>'
      ].join('')
    },
       
    preg_quote ( str ) {
       return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight (needle, haystack) {
      return haystack.replace(
        new RegExp('(' + this.preg_quote(needle) + ')', 'ig'),
        '<span class="highlight">$1</span>'
        )
    },
    rowClassCB (data, index) {
      return (index % 2) === 0 ? 'odd' : 'even'
    },
    onCellClicked (data, field, event) {
      console.log('cellClicked', field.name)
  
      if (field.name !== '__actions') {
        this.$refs.vuetable.toggleDetailRow(data.id)
      }
    },
    onCellDoubleClicked (data, field, event) {
      console.log('cellDoubleClicked:', field.name)
    },
    onCellRightClicked (data, field, event) {
      console.log('cellRightClicked:', field.name)
    },
    onLoadSuccess (response) {
     // set pagination data to pagination-info component
      this.$refs.paginationInfo.setPaginationData(response.data)
      let data = response.data.data
      /*
      if (this.searchFor !== '') {
        for (let n in data) {
          data[n].name = this.highlight(this.searchFor, data[n].name)
          data[n].email = this.highlight(this.searchFor, data[n].email)
        }
      }*/
    },
    onLoadError (response) {
      if (response.status == 400 &&  this.tokenExpired === 0) {
        sweetAlert('Something\'s Wrong!', response.data.message, 'error')
        this.$router.push({name: 'Login'});
      } else if (response.status == 403 || response.status == 401) {
        this.sessionExpired(response.status)
      }else {
       /* if(this.tokenExpired === 0){sweetAlert('Oops', E_SERVER_ERROR, 'error')*/
        this.$router.push({name: 'Login'});
       /* }*/
      }
    },
    onPaginationData (tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination)
      this.$refs.pagination.setPaginationData(tablePagination)
    },
    onChangePage (page) {
            this.$refs.vuetable.changePage(page)
    },
    onInitialized (fields) {
      console.log('onInitialized', fields)
      this.vuetableFields = fields
    },
    onDataReset () {
      console.log('onDataReset')
      this.$refs.paginationInfo.resetData()
      this.$refs.pagination.resetData()
    }

  }
}
</script>
 <style type="text/css">
      .ui.vertical.stripe h3 {
        font-size: 2em;
      }
      .secondary.pointing.menu .toc.item {
        display: none;
      }
      .vuetable {
        margin-top: 1em !important;
      }
      .vuetable-wrapper.ui.basic.segment {
        padding: 0em;
      }
      .vuetable button.ui.button {
        padding: .5em .5em;
        font-weight: 400;
      }
      .vuetable button.ui.button i.icon {
        margin: 0;
      }
      .vuetable td i.handle-icon:hover {
        cursor: pointer;
      }
      .vuetable-actions {
        width: 15%;
        padding: 12px 0px;
        text-align: center;
      }
      .vuetable-pagination {
        background: #f9fafb !important;
      }
      .vuetable-pagination-info {
        margin-top: auto;
        margin-bottom: auto;
      }
      .highlight {
        background-color: yellow;
      }
      .vuetable-detail-row {
        height: 200px;
      }
      .detail-row {
        margin-left: 40px;
      }
      .expand-transition {
        transition: all .5s ease;
      }
      .expand-enter, .expand-leave {
        height: 0;
        opacity: 0;
      }
      tr.odd {
        background-color: #e6f5ff;
      }
      body {
        overflow-y: scroll;
      }
    </style>

 
 
    



// WEBPACK FOOTER //
// src/components/integration-tracking/TrackingList.vue